"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Theme = {
  carvana: {
    body: '#e4ecf0',
    blue: {
      primary: '#00aed9',
      hover: '#018dc0',
      medium: '#00619e',
      dark: '#183558',
      pastel: '#cfeaf2',
      dropdown: '#08689a'
    },
    gray: {
      background: '#f4f8fa',
      light: '#d9dde9',
      medium: '#aab1c7',
      dark: '#757989'
    },
    green: {
      primary: '#1dd08b',
      apple: '#78be20'
    },
    red: {
      primary: '#ff7171'
    },
    white: {
      primary: '#ffffff'
    },
    black: {
      primary: '#000000'
    },
    yellow: {
      primary: '#feb948',
      hover: '#eb9f23',
      pastel: '#fbf2de'
    },
    stroke: {
      blue: '#122946'
    },
    impersonationRed: '#ff0000'
  },
  header: {
    stroke: '#045489',
    background: '#00619e',
    boxShadow: 'rgba(25, 41, 61, 0.13)',
    border: '#eef3f4',
    transparency: {
      hidden: 'rgba(0,0,0,0)',
      partial: 'rgba(0,0,0,0.7)'
    }
  },
  typography: {
    fontFamily: '"Brandon Text", "Lato", sans-serif;',
    fontSize: 16
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 960,
      lg: 1280,
      xl: 1800
    }
  }
};
var _default = Theme;
exports.default = _default;
module.exports = exports.default;